import { render, staticRenderFns } from "./PhoneRow.vue?vue&type=template&id=45ba6946&scoped=true"
import script from "./PhoneRow.vue?vue&type=script&lang=js"
export * from "./PhoneRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ba6946",
  null
  
)

export default component.exports